import * as yup from 'yup';
import { CtaButton } from '@web/molecules';
import { nullableImageFromCMSSchema } from '../schemas';
import { schema as videoModalSchema } from './video_modal';
import { schema as modalSchema } from './cms_modal';

export const component = CtaButton;

export const schema = yup
  .object({
    href: yup.string().required(),
    variant: yup.string().required(),
    children: yup.string().required(),
    openNewTab: yup.boolean(),
    headerText: yup.string(),
    alignment: yup.string(),
    triggerModal: yup.boolean(),
    modal: yup.lazy(item => {
      switch (item?.component) {
        case 'video_modal':
          return videoModalSchema;
        default:
          return modalSchema;
      }
    }),
    icon: nullableImageFromCMSSchema,
    iconAlignment: yup.string(),
    minWidth: yup.number().nullable(),
    fullWidthMobile: yup.boolean(),
    fullWidthDesktop: yup.boolean(),
    sideMargin: yup.boolean(),
  })
  .transform(value => ({
    href: value.href?.url || value.href?.cached_url,
    variant: value.button_variant,
    children: value.button_label,
    openNewTab: value.opens_new_tab,
    headerText: value.headerText,
    alignment: value.alignment || undefined,
    triggerModal: value.trigger_modal,
    modal: value.modal?.[0] || null,
    icon: value.icon || undefined,
    iconAlignment: value.icon_alignment || undefined,
    minWidth: value.min_width || undefined,
    fullWidthMobile: value.full_width_mobile ?? undefined,
    fullWidthDesktop: value.full_width_desktop ?? undefined,
    sideMargin: value.side_margin ?? undefined,
  }));
